import store from "@/core/services/store";
import Swal from "sweetalert2";
import i18n from "@/core/plugins/vue-i18n";

function ShowLoading(){
    store.dispatch('modal/loading' , true)
    store.dispatch('modal/show' , true)
}

function HideLoading(){
    store.dispatch('modal/loading' , false)
    store.dispatch('modal/show' , false)
}

function SetLoading(show){
    if (show)
        ShowLoading();
    else
        HideLoading();
}

function isShowLoading(){
    return store.getters["modal/isLoading"]
}


async function YesNo(message, title= "",closeValue=false, icon = "question"){
    try{
        let response = await Swal.fire({
            title: title,
            text: message,
            icon: icon,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: i18n.t('BUTTONS.Yes'),
            cancelButtonText: i18n.t('BUTTONS.No'),

        })

        return response.isConfirmed;
    }catch (e) {
        return  closeValue;
    }
}

async function Delete(object = null){
    let message = object ? i18n.t("CONFIRM.DeleteA" , {a:object}) : i18n.t("CONFIRM.Delete");
    return await YesNo(message)
}

async function DeleteAll(object = null){
    return await YesNo(i18n.t("CONFIRM.DeleteAll"))
}

async function AccessDenied(){
    CustomResponseDialog(i18n.t("ERRORS.AccessDenied"), i18n.t("ERRORS.AccessDeniedDescription"), "", "media/error/access_denied.png", [{text  : i18n.t("BUTTONS.OK"), click : "close", color : "", class : ""}]);
}

function CustomResponseDialog(title, message, data, image= null , btnConfig = []){
    store.dispatch('modal/loading' , false)
    store.dispatch('modal/title' , title)
    store.dispatch('modal/message' , message)
    store.dispatch('modal/data' , data)
    store.dispatch('modal/show' , true)
    store.dispatch('modal/buttons' , btnConfig)
    store.dispatch('modal/image' , image)
}

function UnKnownErrorDialog(message = null,data="",  image="media/error/unknown_error.jpg", btnConfig=[{text  : "cancel", click : "close", color : "", class : ""}]){
    if (! message) message = i18n.t("ERRORS.TryAgain");

    CustomResponseDialog(i18n.t("ERRORS.UnknownError"), message, data, image, btnConfig)
}

function HideDialog(){
    store.dispatch('modal/show' , false)
}

const exp = {
    isShowLoading,
    HideLoading,
    SetLoading,
    ShowLoading,
    YesNo,
    Delete,
    DeleteAll,
    CustomResponseDialog,
    AccessDenied
}


export default exp


export const install = {
    install(Vue){
        Vue.prototype.$modal = exp
    }
}